export const duration = 250;
export const timingFunction = 'ease-in-out';



// WEBPACK FOOTER //
// ./src/js/util/transitions.js